import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getMerchandise } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddDrugsModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    remainLen: {
      type: Number,
      default: 20
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      keyWord: '',
      manufacture: ''
    });
    const table = ref();
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        form.value = {
          keyWord: '',
          manufacture: ''
        };
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      if (selectRows.length > props.remainLen) {
        ElMessage.warning(`已勾选${20 - props.remainLen}条数据,最多可再勾选${props.remainLen}条数据`);
        return;
      }

      visible.value = false;
      emit('success', selectRows);
    }

    const tableOptions = getVexTableProps({
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getMerchandise(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '药品编码',
        width: '200px',
        field: 'prodNo',
        showOverflow: true
      }, {
        title: '药品名称',
        width: '150px',
        field: 'prodName',
        showOverflow: true
      }, {
        title: '药品规格',
        width: '150px',
        field: 'packageUnit',
        showOverflow: true
      }, {
        title: '批准文号',
        width: '200px',
        field: 'passfileNumber',
        showOverflow: true
      }, {
        title: '生产厂家',
        field: 'manufacturer',
        showOverflow: true
      }]
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "药品",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "1000px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "药品"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.keyWord,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.keyWord = $event),
                  placeholder: "编码/名称/批准文号"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "厂家"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.manufacture,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.manufacture = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                icon: "Search",
                onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};